import { render, staticRenderFns } from "./joinHands.vue?vue&type=template&id=f53258f6&scoped=true&"
import script from "./joinHands.vue?vue&type=script&lang=js&"
export * from "./joinHands.vue?vue&type=script&lang=js&"
import style0 from "./joinHands.vue?vue&type=style&index=0&id=f53258f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53258f6",
  null
  
)

export default component.exports